import { mapGetters, mapActions, mapMutations } from 'vuex'
import Moment from 'moment'
import Const from '@/helper/const'

import {
  StackTraceJson,
  FileDownloadButton
} from '@/components'

import * as UserType from '@/helper/UserType'

export default {
  components: {
    StackTraceJson,
    FileDownloadButton
  },
  data () {
    return {
      isLoading: false,
      userType: UserType,
      idCallManager: '',
      loading: false,
      lastUpdatedAt: null,
      providersTotal: 0,
      startDate: null,
      endDate: null,
      clientName: '',
      providerflowName: '',
      lastProviderUpdated: '',
      lastStatusProvider: '',
      callManagerId: '',
      managerStackTraceJson: false,
      headers: [
        { text: 'Ações', align: 'center', sortable: false },
        { text: 'Provider', value: 'alias', align: 'center' },
        { text: 'Iniciado', value: 'startDate', align: 'left' },
        { text: 'Finalizado', value: 'endDate', align: 'left' },
        { text: 'Tentativas', value: 'countRetry', align: 'left' },
        { text: 'Status', value: 'status', align: 'center' }
      ],
      listActions: [
        {
          name: 'Request provider',
          value: 'request-provider',
          action: (item) => this.showStackTraceJson('request-provider', item),
          disabled: (condition) => this.validateDisabledButton('request-provider', condition)
        },
        {
          name: 'Response provider',
          value: 'response-provider',
          action: (item) => this.showStackTraceJson('response-provider', item),
          disabled: (condition) => this.validateDisabledButton('response-provider', condition)
        },
        {
          name: 'Log sources',
          value: 'log-sources',
          action: (item) => this.showStackTraceJson('log-sources', item),
          disabled: (condition) => this.validateDisabledButton('log-sources', condition)
        },
        {
          name: 'Services',
          value: 'services',
          action: (item) => this.showStackTraceJson('services', item),
          disabled: (condition) => this.validateDisabledButton('services', condition)
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getterListConsultingCallManager',
      'getterAccount'
    ]),
    items () {
      return this.getterListConsultingCallManager.providers
    },
    filteredHeaders () {
      let result = this.headers

      if (this.getterAccount.idUserType !== UserType.USER_IMPLANTADOR && this.getterAccount.idUserType !== UserType.USER_IMPLANTADOR_GUIDE) {
        result = result.filter((item) => item.text !== 'Ações')
      }

      return result
    }
  },
  watch: {
    loading (val) {
      if (!val && (this.items && this.items.length > 0)) {
        this.callManagerId = this.getterListConsultingCallManager.idCallmanager
        this.lastUpdatedAt = this.getterListConsultingCallManager.lastUpdatedAt
        this.providersTotal = this.getterListConsultingCallManager.providers.length
        this.startDate = this.getterListConsultingCallManager.startDate
        this.endDate = this.getterListConsultingCallManager.endDate
        this.clientName = this.getterListConsultingCallManager.clientName
        this.providerflowName = this.getterListConsultingCallManager.providerflowName
        this.lastProviderUpdated = this.getterListConsultingCallManager.lastProviderUpdated
        this.lastStatusProvider = this.getterListConsultingCallManager.lastStatusProvider
      }
    }
  },
  mounted () {
    this.setOrClearData()
  },
  beforeDestroy () {
    this.CLEAR_STACK_TRACE_STORE()
  },
  methods: {
    ...mapActions([
      'actionAllConsulting'
    ]),
    ...mapMutations([
      'SET_SELECTED_PROVIDER_BY_CALL_MANAGER',
      'CLEAR_STACK_TRACE_STORE'
    ]),
    getStackTraceUrl (item, url) {
      return `${Const.SERVICE_STACKTRACE}/${item.idCallManager}/${url}/${item.alias}`
    },
    linkToDownload () {
      this.isLoading = true
      const result = `${Const.SERVICE_DOSSIE}/${this.getterListConsultingCallManager.idProviderFlow}/${this.idCallManager}`
      const fileName = `dossie-${this.idCallManager}.pdf`

      const that = this

      const xhr = new XMLHttpRequest()
      xhr.open('GET', result, true)
      xhr.responseType = 'blob'
      xhr.setRequestHeader('x-access-token', window.localStorage.getItem('access_token'))

      xhr.onload = function () {
        if (this.status === 200) {
          const blob = new Blob([xhr.response], { type: 'application/pdf' })
          const downloadURL = window.URL.createObjectURL(blob)
          const anchor = document.createElement('a')
          anchor.href = downloadURL
          anchor.download = fileName
          document.body.appendChild(anchor)
          anchor.click()
          setTimeout(() => {
            document.body.removeChild(anchor)
            window.URL.revokeObjectURL(downloadURL)
          }, 100)
          that.sendToast(
            {
              text: 'Download do arquivo realizado com sucesso!',
              type: 'success'
            }
          )
        } else {
          that.sendToast(
            {
              text: 'Ocorreu um erro ao fazer o download do arquivo, tente novamente mais tarde!',
              type: 'danger'
            }
          )
        }
      }

      xhr.onerror = function () {
        console.error('An error occurred while downloading the PDF.')
      }

      xhr.send()
      this.isLoading = false
    },
    showStackTraceJson (type, item) {
      const updatedItem = {
        ...item,
        type,
        idCallManager: this.idCallManager
      }

      if (type === 'response-provider') {
        updatedItem.url = this.getStackTraceUrl(updatedItem, 'provider/response')
      }

      if (type === 'request-provider') {
        updatedItem.url = this.getStackTraceUrl(updatedItem, 'provider/request')
      }

      if (type === 'log-sources') {
        updatedItem.url = this.getStackTraceUrl(updatedItem, 'sources')
      }

      if (type === 'services') {
        updatedItem.url = this.getStackTraceUrl(updatedItem, 'services')
      }

      if (type === 'response-dossie') {
        updatedItem.url = `${Const.SERVICE_CALL_MANAGER}/${this.getterListConsultingCallManager.idProviderFlow}/${this.getterListConsultingCallManager.idCallmanager}`
      }

      this.SET_SELECTED_PROVIDER_BY_CALL_MANAGER(updatedItem)

      this.managerStackTraceJson = true
    },
    validateDisabledButton (type, item) {
      let result = false

      switch (type) {
        case 'response-provider':
          result = ((item.status === 'PROCESS' || item.status === 'QUEUED') && item.countResponses === 0) || ((item.status === 'TIMEOUT') && item.countResponses <= 1)
          break
        default:
          result = false
      }

      return result
    },
    setOrClearData () {
      if (Object.keys(this.$route.query).length > 0 && this.$route.query.idCallManager) {
        this.idCallManager = this.$route.query.idCallManager

        this.getData()
      } else {
        this.clearData()
      }
    },
    formatData (date) {
      if (date) {
        return Moment(date).format('DD/MM/YYYY [às] HH:mm:ss')
      }
    },
    verifyStatusText (status) {
      let result = ''

      switch (status) {
        case 'SUCCESS':
          result = 'Sucesso'
          break
        case 'PROCESS':
          result = 'Processando'
          break
        case 'QUEUED':
          result = 'Em fila'
          break
        case 'ERROR':
          result = 'Erro'
          break
        case 'TIMEOUT':
          result = 'Timeout'
          break
        case 'CACHE':
          result = 'Em Cache'
          break
        default:
          result = 'Desconhecido'
      }

      return result
    },
    verifyStatusColor (status) {
      let result = ''

      switch (status) {
        case 'SUCCESS':
          result = 'green'
          break
        case 'PROCESS':
          result = 'primary'
          break
        case 'QUEUED':
          result = 'orange'
          break
        case 'ERROR':
          result = 'red'
          break
        case 'TIMEOUT':
          result = 'secondary'
          break
        case 'CACHE':
          result = 'purple'
          break
        default:
          result = 'gray'
      }

      return result
    },
    getData () {
      const params = {
        idCallManager: this.idCallManager
      }

      this.loading = true

      this.actionAllConsulting(params)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          if (error && error.status) {
            if (error.status === 404) {
              this.sendToast({
                text: 'Nenhum dado foi encontrado para o ID informado.',
                type: 'warning'
              })
            }

            if (error.status === 400) {
              this.sendToast({
                text: 'O ID informado está incorreto!',
                type: 'warning'
              })
            }
          } else {
            this.sendToast({
              text: 'API para busca de dados se encontra inoperante',
              type: 'danger'
            })
          }

          this.clearData()
        })
    },
    clearData () {
      this.callManagerId = ''
      this.providersTotal = 0
      this.lastUpdatedAt = this.startDate = this.endDate = null
      this.clientName = ''
      this.providerflowName = ''
      this.lastProviderUpdated = ''
      this.loading = false

      this.CLEAR_STACK_TRACE_STORE()
    }
  }
}
